import { useState, useRef, useEffect } from 'react';
import MusicPlayerUI from '../components/MusicPlayerUI';
import HorizontalScrollMediaView from '../components/HorizontalScrollMediaView';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { getRelatedSingles, getSingleById } from '../data/singles';
import { ArrowLeft, Home } from 'lucide-react';
import Footer from '../components/Footer';

const Single = () => {

  document.title = "Single";
  
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);
  const { singleId } = useParams();
  const relatedSingles = getRelatedSingles(Number(singleId));
  const navigate = useNavigate();
  const single = getSingleById(Number(singleId));

  useEffect(() => {
    if (single === null) {
      navigate('/404');
    }
  }, []);

  if (single === null) {
    return null;
  }

  const handlePlayPause = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    setCurrentTime(audio.currentTime);
  };

  return (
    <div className="bg-midnight px-2 sm:px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-20 flex flex-col items-center justify-center min-h-screen py-4">
      <div className="absolute top-5 left-3 flex gap-2">
        <button
          onClick={() => navigate(-1)}
          className="p-2 bg-charcoal rounded-full hover:bg-hover-charcoal transition duration-300"
        >
          <ArrowLeft className="text-white w-5 h-5" />
        </button>
        <Link
          to="/"
          className="p-2 bg-charcoal rounded-full hover:bg-hover-charcoal transition duration-300"
        >
          <Home className="text-white w-5 h-5" />
        </Link>
      </div>
      <div className="flex items-center justify-center mb-4 sm:mb-8 mt-10">
        <h1 className="text-2xl sm:text-4xl font-bold text-center">{single.title}</h1>
      </div>
      <div className="relative w-[70vw] sm:w-[50vw] md:w-[40vw] lg:w-[50vw] xl:w-[35vw] hover:bg-hover-charcoal rounded-lg">
        <div className="relative pb-[100%]">
          <img
            src={single.cover_art}
            alt={single.title}
            className="absolute flex top-0 left-0 w-full h-full rounded-lg object-cover"
          />
        </div>
      </div>
      <div className="w-full my-4">
        <MusicPlayerUI
          track={single}
          isPlaying={isPlaying}
          currentTime={currentTime}
          handlePlayPause={handlePlayPause}
        />
      </div>
      {relatedSingles.length > 0 && 
        <HorizontalScrollMediaView 
          collection={relatedSingles} 
          headTitle={`More Singles by ${single.artist}`} 
          route="single" 
        />
      }
      <audio
        ref={audioRef}
        src={single.audio_src}
        onTimeUpdate={handleTimeUpdate}
      ></audio>
      <Footer />
    </div>
  );
};

export default Single;